import React, { useState, useEffect } from "react";
import axios from "axios";

const LeaveCreditsPage = () => {
  const [kitchens, setKitchens] = useState([]);
  const [selectedKitchen, setSelectedKitchen] = useState("");
  const [monthYear, setMonthYear] = useState("");
  const [summary, setSummary] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchKitchens();
    // Set current month
    const now = new Date();
    const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    setMonthYear(currentMonth);
  }, []);

  useEffect(() => {
    if (monthYear) {
      fetchCredits();
    }
  }, [monthYear, selectedKitchen]);

  const fetchKitchens = async () => {
    try {
      const res = await axios.get(
        "https://ims-attendanceback.indevconsultancy.in/api/kitchen-list"
      );
      setKitchens(res.data.kitchens || []);
    } catch (error) {
      console.error("Error fetching kitchens:", error);
    }
  };

  const fetchCredits = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (selectedKitchen) params.append("kitchen_id", selectedKitchen);
      if (monthYear) params.append("month_year", monthYear);

      const res = await axios.get(
        `https://ims-attendanceback.indevconsultancy.in/api/leave-credits-summary/?${params}`
      );

      if (res.data.status) {
        setSummary(res.data.summary);
        setEmployees(res.data.employees || []);
      }
    } catch (error) {
      console.error("Error fetching credits:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-3 py-3 bg-cream" style={{ minHeight: "100vh" }}>
      <div className="card">
        <div className="card-header bg-skyBlue text-white">
          <h5 className="mb-0">Employee Leave Credits Dashboard</h5>
        </div>
        <div className="card-body">
          {/* Filters */}
          <div className="row mb-4 g-3">
            <div className="col-md-4">
              <label className="form-label">Kitchen</label>
              <select
                className="form-select"
                value={selectedKitchen}
                onChange={(e) => setSelectedKitchen(e.target.value)}
              >
                <option value="">All Kitchens</option>
                {kitchens.map((k) => (
                  <option key={k.kitchenid} value={k.kitchenid}>
                    {k.kitchen_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label">Month</label>
              <input
                type="month"
                className="form-control"
                value={monthYear}
                onChange={(e) => setMonthYear(e.target.value)}
              />
            </div>

            <div className="col-md-4 d-flex align-items-end">
              <button className="btn btn-primary w-100" onClick={fetchCredits}>
                Refresh
              </button>
            </div>
          </div>

          {/* Summary Cards */}
          {summary && (
            <div className="row g-3 mb-4">
              <div className="col-md-3">
                <div className="card text-white" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" }}>
                  <div className="card-body text-center">
                    <h6>Total Employees</h6>
                    <h2>{summary.total_employees}</h2>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card text-white" style={{ background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" }}>
                  <div className="card-body text-center">
                    <h6>Credits Earned</h6>
                    <h2>{summary.total_credits_earned}</h2>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card text-white" style={{ background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)" }}>
                  <div className="card-body text-center">
                    <h6>Credits Used</h6>
                    <h2>{summary.total_credits_used}</h2>
                  </div>
                </div>
              </div>

              <div className="col-md-3">
                <div className="card text-white" style={{ background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)" }}>
                  <div className="card-body text-center">
                    <h6>Credits Remaining</h6>
                    <h2>{summary.total_credits_remaining}</h2>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Employee Credits Table */}
          <div className="table-responsive">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
                <p>Loading credits...</p>
              </div>
            ) : (
              <table className="table table-bordered table-striped">
                <thead className="table-light">
                  <tr>
                    <th>S.No</th>
                    <th>Emp Code</th>
                    <th>Name</th>
                    <th>Kitchen</th>
                    <th>Offs Worked</th>
                    <th>Credits Earned</th>
                    <th>Credits Used</th>
                    <th>Remaining</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data available for selected month
                      </td>
                    </tr>
                  ) : (
                    employees.map((emp, index) => (
                      <tr key={emp.id}>
                        <td>{index + 1}</td>
                        <td>{emp.employee_code}</td>
                        <td>{emp.employee_name}</td>
                        <td>{emp.kitchen_name}</td>
                        <td>{emp.offs_worked}</td>
                        <td>
                          <span className="badge bg-success">{emp.accumulated_credits}</span>
                        </td>
                        <td>
                          <span className="badge bg-warning">{emp.leaves_adjusted}</span>
                        </td>
                        <td>
                          <span className="badge bg-primary">{emp.remaining_credits}</span>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveCreditsPage;